import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';

export interface IPhoneButtonProps {
  onClick(): void;
  testId?: string;
  onlyIcon?: boolean;
}

export const PhoneButton: React.FC<IPhoneButtonProps> = ({ onlyIcon, onClick, testId = 'PhoneButton' }) => {
  if (onlyIcon) {
    return (
      <Button
        beforeIcon={<IconCommunicationPhone16 color="current_color" />}
        data-testid={testId}
        onClick={onClick}
        size="M"
        theme="fill_primary"
      />
    );
  }

  return (
    <Button data-testid={testId} onClick={onClick} size="M" theme="fill_primary">
      Позвонить
    </Button>
  );
};
